import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer/Footer';
import SettingHeader from './SettingHeader';
import MoveToTop from '../MoveTotop/MoveToTop';

function NewSettings() {
  return (
    <div>
      <SettingHeader />
      <div className="contents"><Outlet /></div>
      <Footer />
      <MoveToTop />
    </div>
  );
}

export default NewSettings;
